import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { useApiClient } from "../../api/ApiContext";
import { queryKeys } from "../../api/queryKeys";
import { workDaysSchema } from "../../api/schemas";
import type { WorkDaysResponse } from "../../api/schemas";
import type { DateRange } from "./model/period";

/**
 * Loads the working days of the signed-in person (`GET /me/workdays`, at most 93 days).
 *
 * @param range - Inclusive date range.
 * @returns The query result.
 */
export function useWorkDays(range: DateRange): UseQueryResult<WorkDaysResponse> {
  const client = useApiClient();
  const query = useQuery({
    queryKey: queryKeys.workDays(range.from, range.to),
    queryFn: ({ signal }) =>
      client.get("/api/v1/me/workdays", workDaysSchema, {
        query: { from: range.from, to: range.to },
        signal,
      }),
    placeholderData: keepPreviousData,
  });

  return query;
}
